import { Dispatch, ReactNode, SetStateAction, useCallback } from "react"
import { makeStyles } from "tss-react/mui"
import { MenuItem } from "@mui/material"
import { DialogContent, Grid } from "@mui/material"

import { StandardButton } from "../../../../../../shared/components/buttons/StandardButton"
import { StandardDialog } from "../../../../../../shared/components/dialogs/StandardDialog"
import { HoverActionMenu } from "../../../../../../shared/components/table/HoverActionMenu"

const useStyles = makeStyles()((theme) => ({
    addButton: {
        background: "#2196F3",
    },
    dialogContent: {},
}))

interface ActionMenuItem {
    text: string
    onClick: (item: any) => void
}

interface ActionMenuProps {
    item: any
    menuItems: ActionMenuItem[]
}

export const ActionMenu = ({ item, menuItems }: ActionMenuProps) => {
    return (
        <Grid container justifyContent="center">
            <HoverActionMenu>
                {(closeMenu) =>
                    menuItems.map((menuItem, index) => (
                        <MenuItem
                            key={index}
                            onClick={() => {
                                menuItem.onClick(item)
                                closeMenu()
                            }}
                        >
                            {menuItem.text}
                        </MenuItem>
                    ))
                }
            </HoverActionMenu>
        </Grid>
    )
}

type AddButtonProps = Readonly<{
    title: string
    setDialogState: Dispatch<SetStateAction<boolean>>
}>

export const AddButton = ({ title, setDialogState }: AddButtonProps) => {
    const { classes } = useStyles()
    const handleAddClick = useCallback(() => {
        setDialogState((prev) => !prev)
    }, [setDialogState])
    return (
        <Grid>
            <StandardButton onClick={handleAddClick} fullWidth={false} color="primary" className={classes.addButton}>
                {title}
            </StandardButton>
        </Grid>
    )
}

type DialogProps = Readonly<{
    dialogState: boolean
    setDialogState: Dispatch<SetStateAction<boolean>>
    title: string
    children: ReactNode
}>

export const SelectionDialog = ({ dialogState, setDialogState, title, children }: DialogProps) => {
    const { classes } = useStyles()
    const handleClose = useCallback(() => {
        setDialogState((prev) => !prev)
    }, [setDialogState])

    return (
        <StandardDialog dialogTitle={title} open={dialogState} onClose={handleClose} maxWidthProp="sm" scroll="body">
            <DialogContent className={classes.dialogContent}>{children}</DialogContent>
        </StandardDialog>
    )
}
